/* This file contains scent mappings for both product scents and bundle profile scents */

export const scentMapping: {
  [scentName: string]: { src: string; bgColor: string };
} = {
  Unscented: {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-Unscented-iconfill.svg?v=1605289319",
    bgColor: "bg-white",
  },
  "Orange Blossom": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-OrangeBlossom-iconfill.svg?v=1605289319",
    bgColor: "bg-scent-orange-blossom",
  },
  "Lemon Verbena": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-LemonVerbena-iconfill.svg?v=1647353907",
    bgColor: "bg-scent-lemon-verbena",
  },
  Lemon: {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-Lemon-iconfill.svg?v=1605289319",
    bgColor: "bg-scent-lemon",
  },
  "Lemon Citrus": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-Lemon-iconfill.svg?v=1605289319",
    bgColor: "bg-scent-lemon",
  },
  "Forest Air": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-ForestAir-iconfill.svg",
    bgColor: "bg-scent-forest-air",
  },
  "Fresh Air": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-FreshScent-iconfill.svg?v=1605289319",
    bgColor: "bg-scent-fresh-air",
  },
  "Fresh Rain": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/icon-Fresh_Rain-iconfill.svg?v=1654546766",
    bgColor: "bg-scent-fresh-rain",
  },
  "Fresh Start": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-FreshStart-iconfill.svg",
    bgColor: "bg-scent-fresh-start",
  },
  "Lavender Chamomile": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-LavenderChamomile-iconfill.svg",
    bgColor: "bg-scent-lavender-chamomile",
  },
  "Lavender Eucalyptus": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-LavendarEucalyptus-iconfill.svg?v=1605289320",
    bgColor: "bg-scent-lavender-eucalyptus",
  },
  "Lavender Meadow": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-LavendarEucalyptus-iconfill.svg?v=1605289320",
    bgColor: "bg-scent-lavender-meadow",
  },
  "Rose Energy": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-RoseEnergy-iconfill.svg",
    bgColor: "bg-scent-rose-energy",
  },
  "Jasmine Honeysuckle": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-JasmineHoneysuckle-iconfill.svg?v=1648579928",
    bgColor: "bg-scent-jasmine-honeysuckle",
  },
  "Home for the Holidays": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-HomeFortheHolidays-iconfill.svg",
    bgColor: "bg-scent-home-for-the-holidays",
  },
  Ocean: {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/icon-Ocean-iconfill.svg?v=1654524602",
    bgColor: "bg-scent-ocean",
  },
  "Clean & Crisp": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-CleanScent-iconfill.svg?v=1605289319",
    bgColor: "bg-scent-clean-and-crisp",
  },
  "Crisp Breeze": {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent-CleanScent-iconfill.svg?v=1605289319",
    bgColor: "bg-scent-crisp-breeze",
  },
  Refreshing: {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent_profile-Refreshing-iconfill.svg?v=1688668443",
    bgColor: "bg-scent-fresh-rain",
  },
  Calm: {
    src: "//cdn.shopify.com/s/files/1/0268/4219/files/scent_profile-Calm-iconfill.svg?v=1688668443",
    bgColor: "bg-scent-lavender-chamomile",
  },
};
